import axios from "axios";
import { jsonHeader } from '../util/GeneralUtil';
import * as BullCache from "../util/BullCache";

const apiUrl = process.env.REACT_APP_API_URL;

var user = BullCache.getFromCache("user");

async function uploadRateOfPoint(payload) {
    const result = await axios.post(`${apiUrl}/script/upload/rateofpoint/${user.adminId}`, payload, {
    });
    return result.data || [];
}

async function getRateOfPoint(payload) {
    const result = await axios.post(apiUrl + "/script/get/rateofpoint",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function updateRateOfPoint(payload) {
    const result = await axios.post(apiUrl + "/script/add/rateofpoint",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const RateOfPointService = {
    uploadRateOfPoint,
    getRateOfPoint,
    updateRateOfPoint,
}